import styled from 'styled-components';

export const UserListResultsContainer = styled.div<{ height: number }>`
  max-height: ${props => props.height}px;
  overflow: auto;
`;

export const UserListItemResultsContainer = styled.div`
  padding: 10px 15px;
  cursor: pointer;
   
  &:hover{
    background-color: ${({ theme }) => theme.palette.gray['200']};
  }
`;